import { defineComponent as o, openBlock as a, createBlock as n, unref as r, withCtx as i, createElementVNode as s } from "vue";
import l from "../SfIconBase/SfIconBase.vue.mjs";
import { SfIconSize as f } from "@storefront-ui/shared";
const u = /* @__PURE__ */ o({
  __name: "SfIconClose",
  props: {
    size: {
      type: String,
      default: f.base
    }
  },
  setup(t) {
    return (m, e) => (a(), n(r(l), {
      size: t.size,
      viewBox: "0 0 24 24",
      "data-testid": "close"
    }, {
      default: i(() => e[0] || (e[0] = [
        s("path", { d: "M18.295 5.705a1 1 0 0 1 0 1.41L13.41 12l4.885 4.885a.997.997 0 1 1-1.41 1.41L12 13.41l-4.885 4.885a.997.997 0 1 1-1.41-1.41L10.59 12 5.705 7.115a.997.997 0 0 1 1.41-1.41L12 10.59l4.885-4.885a.997.997 0 0 1 1.41 0" }, null, -1)
      ])),
      _: 1
    }, 8, ["size"]));
  }
});
export {
  u as default
};
